import utils from 'util/utils'
import auth from '../auth'

const { sendRequest } = utils

const getNotificationsList = async (user, type) => {
    const token = auth.getToken(),
        route = `/notifications?user=${user}&type=${type}`,
        request = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }
    return await sendRequest(route, request)
}


export default {
    getNotificationsList
}